import { actions } from './actions';
import { mutations } from './mutations';
import { Pagination } from 'packages/core/Pagination';
import { ThreadListMetadata } from 'packages/email/entities/ThreadListMetadata';
var state = {
    threads: [],
    selectedThread: null,
    meta: new ThreadListMetadata(),
    pagination: new Pagination(),
    loading: false,
};
export var talentEmailState = {
    namespaced: true,
    state: state,
    actions: actions,
    mutations: mutations,
};
